import Blog from "../../components/blogpage";

export default Blog;
